import { useEffect, useState } from 'react';
import { transformWpPost } from '../utils/kart';

export function useKartLocations() {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const restUrl = window.sar61KartData?.restUrl || '/wp-json/wp/v2/sar61_sted';
        const nonce = window.sar61KartData?.nonce || '';

        fetch(`${restUrl}?per_page=100&_fields=id,title,kart_meta`, {
            headers: nonce ? { 'X-WP-Nonce': nonce } : {}
        })
            .then(r => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then(posts => {
                const mapped = posts
                    .map(transformWpPost)
                    .filter(l => l.coordinates[0] !== 0 && l.coordinates[1] !== 0);
                setLocations(mapped);
            })
            .catch(() => {
                setLocations([]);
            })
            .finally(() => setLoading(false));
    }, []);

    return { locations, loading };
}
